/* theme/assets/fm-plans.js — plan grid tabs (Ritmovio spec 2026-10-23 §4.2–§4.3).
   Pure helpers on window.FmPlans (tests: globalThis.FmPlans); in the browser it also binds every [data-fm-plans].
   The tab row ships hidden, so without JS every card shows; this script reveals only the tabs worth showing. */
(function (root) {
  /** Does a card in `groups` (its collection handles) show under `tab`? '' is All. */
  function matches(groups, tab) {
    return !tab || groups.includes(tab);
  }

  /** Tab handles to reveal: none on a group's own page; only tabs with a card; none unless two remain. */
  function tabsToShow(cardGroups, tabs, page) {
    if (page && tabs.includes(page)) return [];
    const shown = tabs.filter((t) => cardGroups.some((g) => g.includes(t)));
    return shown.length >= 2 ? shown : [];
  }

  root.FmPlans = { matches, tabsToShow };

  if (typeof document === 'undefined') return;
  function bind(el) {
    const cards = [...el.querySelectorAll('.fm-plans__card')];
    const groups = cards.map((c) => (c.dataset.groups || '').split(' ').filter(Boolean));
    const buttons = [...el.querySelectorAll('[data-fm-tab]')];
    const show = tabsToShow(groups, buttons.map((b) => b.dataset.fmTab).filter(Boolean), el.dataset.pageCollection || '');
    if (!show.length) return;
    for (const b of buttons) b.hidden = !!b.dataset.fmTab && !show.includes(b.dataset.fmTab);
    el.querySelector('.fm-plans__tabs').hidden = false;
    el.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-fm-tab]');
      if (!btn || !el.contains(btn)) return;
      for (const b of buttons) b.setAttribute('aria-selected', String(b === btn));
      cards.forEach((c, i) => { c.hidden = !matches(groups[i], btn.dataset.fmTab); });
    });
  }
  const init = () => document.querySelectorAll('[data-fm-plans]').forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})(typeof window !== 'undefined' ? window : globalThis);
